import { Store } from 'store/index';
import getProductId from './getProductId';

const getPredesignedProductItem = (store: Store) => {
  const productId = getProductId(store);
  const targetProduct = store.product.designProduct?.designAbstractProduct.designProductItems?.find(
    (productItem) => productItem.product.productId === productId,
  );
  return targetProduct;
};

export default getPredesignedProductItem;
